import { render, staticRenderFns } from "./DataBySpeed.vue?vue&type=template&id=e996f2e4&"
import script from "./DataBySpeed.vue?vue&type=script&lang=js&"
export * from "./DataBySpeed.vue?vue&type=script&lang=js&"
import style0 from "./DataBySpeed.vue?vue&type=style&index=0&id=e996f2e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports